// src/routes/PrivateRoute.jsx
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PrivateRoute = ({ children }) => {
  const { userData } = useAuth();

  if (!userData) {
    return <Navigate to="/register" replace />;
  }

  return children;
};

export default PrivateRoute;
